import { Component, Inject } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
} from '@angular/material/dialog';
import { DialogSuccess } from '@models/dialogs/DialogSuccess';

@Component({
	selector: 'ui-success-dialog',
	templateUrl: './success-dialog.component.html',
	styleUrls: ['./success-dialog.component.scss'],
})
export class UISuccessDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<UISuccessDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DialogSuccess
	) {
		this.data = {
			title: data.title || '¡Listo!',
			message: data.message,
			paragraphs: data.paragraphs || [],
		};
	}

	closeDialog(): void {
		this.dialogRef.close();
	}
}
